import { GLOBAL_ENCRYPTION_KEY } from '../constants';
import Aes256 from '../helpers/Aes256';
import { dataGeoServiciosFetch, dataAxureFetch } from './fetch';
import html2canvas from "html2canvas";


export function getAppConfiguration() {
    const aes256 = new Aes256();
    const authState = sessionStorage.getItem('authState');
    if (authState) {
        return JSON.parse(aes256.decrypt(authState, GLOBAL_ENCRYPTION_KEY));
    } else {
        return {
            cheking: false,
        };
    }
}

export function getGisConfiguration() {
    const aes256 = new Aes256();
    const gisState = sessionStorage.getItem('gisState');
    if (gisState) {
        return JSON.parse(aes256.decrypt(gisState, GLOBAL_ENCRYPTION_KEY));
    } else {
        return {
            dataBar: null,
            dataPronostico: [],
        };
    }
}

/**
 * To invert coordinates for the map
 * @param {Array} coordinates -Long, Lat
 */
export function invertCoordinates(coordinates) {
    return [coordinates[1], coordinates[0]];
}


/**
 * To get legends 
 * @param {object} parameters -information about petition
 * @returns {Array} array with information about leyend
 */
 export const getLegend = async(parameters) =>{
    const legend = await dataGeoServiciosFetch(parameters, 'POST')
    return  legend
}

/**
 * To get legends Points
 * @param {object} parameters -information about petition
 * @returns {Array} array with information about leyend
 */
export const getLegendPoints = async(parameters)=>{
    const legendPoints = await dataAxureFetch(parameters, 'POST')
    return  legendPoints
}


/**
 * HTML to PNG
 * @param {String} id id of element html
 * @returns {ImageData} element transform in image
 */
export const htmlToCanvasImage = async(id) =>{
    let element = window.document.getElementById(id);
    const canvas = await html2canvas(element)
    const image = canvas.toDataURL('img/png');
    return image
}


